import { MDBAlert, MDBBtn, MDBSpinner } from 'mdb-react-ui-kit';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import SaveChanges from '../saveCancel';

function CallParking({ setEdited, register, setValue, watch, errors }) {
    const { t, i18n } = useTranslation();
    const [isloading, setIsloading] = useState(false);
    const [internalError, setInternalError] = useState(false);
    const navigate = useNavigate();
    const [rerender, setrerender] = useState(true);
    const [successMessage, setSuccessMessage] = useState("");
    const [showSaveChanges, setshowSaveChanges] = useState(false);
    const [timeout, settimeout] = useState(0);
    const [oldtimeout, setoldtimeout] = useState(0);
    const [timeoutError, settimeoutError] = useState("");



    return (
        <>
            {/* <div className="general-settings pb-3">
                {t("CallParking")}
            </div> */}
            <div>
                <div className="add-numbermain">
                    <div className="tel-numbers">
                       <p> {"Parking Timeout"}</p>
                        <span class="phrecording text-secondary">Maximum duration a call can remain parked</span>
                    </div>
                    <div className="w-30 me-4 position-relative">
                        <input
                            type="text"
                            // value={timeout}
                            maxLength={3}
                            className="selectname w-100 sec-tootip"
                            {...register("global_settings.global_acc_settings.aa_settings.parking_timeout", {
                                valueAsNumber: true,
                                min: {
                                    value: 30, // > 30
                                    message: "Parking Timeout Should be in between 30 seconds and 600 seconds.",
                                },
                                max: {
                                    value: 600, // < 600
                                    message: "Parking Timeout Should be in between 30 seconds and 600 seconds.",
                                }, 
                                        required: "Parking Timeout is required"
                            })}
                        />
                         <span class="seconds">Seconds</span>
                        {errors?.global_settings?.global_acc_settings?.aa_settings?.parking_timeout && (
                            <p className='text-danger mt-1'>
                                {errors.global_settings.global_acc_settings.aa_settings.parking_timeout.message}
                            </p>
                        )}

                    </div>
                </div>
            </div>
            {/* <div className="add-numbermain">
                <div className="tel-numbers">
                    {"Parking Extension"}
                </div>
                <div className="w-30 me-4 text-end">
                    <div className="phoneselect">
                        2020
                    </div>
                </div>
            </div> */}
        </>
    )
}

export default CallParking
